import BillingsOrderCargoTaxiRecalculateRequest, {
  BillingsOrderCargoTaxiRecalculateRequestBody,
} from "./billings-order-cargo-taxi-recalculate.request";

const createBody = (
  request: BillingsOrderCargoTaxiRecalculateRequest,
): BillingsOrderCargoTaxiRecalculateRequestBody => {
  return {
    billingNodes: request.billingNodes,
    billingContributions: request.billingContributions,
  };
};

const billingsOrderCargoTaxiRecalculateRequestFactory = {
  createBody,
};

export default billingsOrderCargoTaxiRecalculateRequestFactory;
